import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Wrapper } from "../../styled";

const SHeader = styled.header`
  position: relative;
  background-color: hsl(173, 14%, 12%);
  &__navigation {
    height: 100%;
  }
`;

const Navigation = styled.nav`
  height: 100%;
`;

const Menu = styled.ul`
  display: flex;
  height: 100%;
  list-style: none;
`;

const MenuItem = styled.li`
  flex-grow: 1;
  height: 100%;
  font-weight: 400;
  letter-spacing: 1.5px;
  text-align: center;
  color: hsl(180, 7%, 57%);
`;

const RouterLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 1.7rem;
  color: inherit;
  &:hover {
    transform: scale(1.1);
    transition: 0.2s;
    color: hsl(180, 31%, 82%);
    background-color: hsl(173, 12%, 27%);
    opacity: 0.9;
  }
  &:active {
    color: hsl(0, 0%, 100%);
  }
`;

const menuItems = [
  { link: "/", title: "About me" },
  { link: "/portfolio", title: "Portfolio" },
  { link: "/experience", title: "Download CV" },
];

export const Header = () => {
  return (
    <SHeader>
      <Wrapper>
        <Navigation>
          <Menu>
            {menuItems.map(({ link, title }, i) => {
              return (
                <MenuItem key={i}>
                  <RouterLink to={link}>{title}</RouterLink>
                </MenuItem>
              );
            })}
          </Menu>
        </Navigation>
      </Wrapper>
    </SHeader>
  );
};
